import { instance } from '../instance';

export const listMySql = (param) => instance.post('aliyun/datasource/listdatasource', param);

export const queryInstancesNetInfo = (param) => instance.post('aliyun/datasource/querynetinfo', param);

export const queryWhiteListExist = (param) => instance.post('aliyun/rds/querywhitelistneedadd', param);

export const addClusterWhiteList = (param) => instance.post('aliyun/rds/addclusterwhitelist', param);
